(() => {
  if (window.SheltaFlexComponents) return;
  window.SheltaFlexComponents = true;
  const rootSelector = '[data-sf-component]';
  const faqStates = new WeakMap();
  function updateFaqSticky(root) {
    const controls = root.querySelector('.sf-faq__controls');
    if (!controls) return;
    if (!window.matchMedia('(max-width: 749px)').matches) {
      controls.classList.remove('is-mobile-sticky');
      return;
    }
    const requested = parseFloat(getComputedStyle(root).getPropertyValue('--header-offset-mobile')) || 0;
    const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || document.querySelector('.section-header')?.getBoundingClientRect().height || 64;
    const inset = Math.max(headerHeight, requested) + 4;
    root.style.setProperty('--sf-faq-sticky-top', inset + 'px');
    const firstGroup = Array.from(root.querySelectorAll('[data-group]')).find(group => !group.hidden) || root.querySelector('[data-empty]');
    const start = firstGroup ? firstGroup.getBoundingClientRect().top - inset - controls.getBoundingClientRect().height : Infinity;
    controls.classList.toggle('is-mobile-sticky', start <= 0);
  }
  let stickyFrame = 0;
  function scheduleSticky() {
    if (stickyFrame) return;
    stickyFrame = requestAnimationFrame(() => {
      stickyFrame = 0;
      document.querySelectorAll('[data-sf-component="faq"]').forEach(updateFaqSticky);
    });
  }
  window.addEventListener('scroll', scheduleSticky, {passive: true});
  window.addEventListener('resize', scheduleSticky);
  function closeFaq(root) {
    root.querySelectorAll('[data-question]').forEach(q => q.setAttribute('aria-expanded', 'false'));
    root.querySelectorAll('[data-answer]').forEach(a => a.classList.remove('is-open'));
  }
  function filterFaq(root) {
    const active = faqStates.get(root) || 'all';
    const term = (root.querySelector('[data-search]')?.value || '').trim().toLowerCase();
    root.querySelectorAll('[data-item]').forEach(item => {
      item.hidden = !(active === 'all' || item.dataset.category === active) || !!(term && !(item.dataset.search || '').toLowerCase().includes(term));
    });
    let total = 0;
    root.querySelectorAll('[data-group]').forEach(group => {
      const count = Array.from(group.querySelectorAll('[data-item]')).filter(item => !item.hidden).length;
      group.hidden = count === 0;
      const label = group.querySelector('[data-count]');
      if (label) label.textContent = count + (count === 1 ? ' Frage' : ' Fragen');
      total += count;
    });
    const empty = root.querySelector('[data-empty]');
    if (empty) empty.hidden = total !== 0;
    closeFaq(root);
    updateFaqSticky(root);
  }
  function selectTab(root, tab) {
    const explorer = root.dataset.sfComponent === 'explorer';
    const selector = explorer ? '[data-sf-tab]' : '[data-tab]';
    root.querySelectorAll(selector).forEach(item => {
      const selected = item === tab;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    if (explorer) {
      const index = Number(tab.dataset.tabIndex);
      root.querySelectorAll('[data-sf-panel]').forEach(panel => panel.classList.toggle('is-active', Number(panel.dataset.panelIndex) === index));
    } else {
      faqStates.set(root, tab.dataset.tab);
      filterFaq(root);
    }
  }
  function init(scope) {
    const roots = Array.from(scope.querySelectorAll(rootSelector));
    if (scope.matches?.(rootSelector)) roots.unshift(scope);
    roots.forEach(root => {
      const selector = root.dataset.sfComponent === 'explorer' ? '[data-sf-tab]' : '[data-tab]';
      root.querySelectorAll(selector).forEach(tab => tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1);
      if (root.dataset.sfComponent === 'faq') {
        faqStates.set(root, root.querySelector('[data-tab][aria-selected="true"]')?.dataset.tab || 'all');
        filterFaq(root);
      }
    });
  }
  document.addEventListener('click', event => {
    const target = event.target.closest?.('[data-sf-tab], [data-tab], [data-question]');
    const root = target?.closest(rootSelector);
    if (!root) return;
    if (target.matches('[data-sf-tab], [data-tab]')) selectTab(root, target);
    else if (root.dataset.sfComponent === 'faq') {
      const open = target.getAttribute('aria-expanded') === 'true';
      closeFaq(root);
      if (!open) {
        target.setAttribute('aria-expanded', 'true');
        target.closest('[data-item]')?.querySelector('[data-answer]')?.classList.add('is-open');
      }
    }
  });
  document.addEventListener('input', event => {
    if (!event.target.matches?.('[data-search]')) return;
    const root = event.target.closest('[data-sf-component="faq"]');
    if (root) filterFaq(root);
  });
  document.addEventListener('keydown', event => {
    const root = event.target.closest?.(rootSelector);
    if (!root) return;
    const selector = root.dataset.sfComponent === 'explorer' ? '[data-sf-tab]' : '[data-tab]';
    const tab = event.target.closest(selector);
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = Array.from(root.querySelectorAll(selector));
    let index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    selectTab(root, tabs[index]);
    tabs[index].focus();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest?.('[data-sf-panel]');
    const root = panel?.closest('[data-sf-component="explorer"]');
    const tab = root?.querySelector('[data-sf-tab][data-tab-index="' + panel.dataset.panelIndex + '"]');
    if (tab) selectTab(root, tab);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
})();
